<template>
    <el-form label-width="150px" class="detail">
        <div class="detail-tab">Base Info</div>
        <el-form-item label="User Id" >
            <div>{{result.user_id}}</div>
        </el-form-item>
        <el-form-item label="User Name"  >
            <div>{{result.user_name}}</div>
        </el-form-item>
        <el-form-item label="User Group"  >
            <div>{{result.group_name}}</div>
        </el-form-item>
        <el-form-item label="Email"  >
            <div>{{result.email}}</div>
        </el-form-item>
        <el-form-item label="Status"  >
            <div :class="'status-'+result.status">{{result.status&&result.status.toUpperCase()}}</div>
        </el-form-item>
        <el-form-item label="Phone"  >
            <div>{{result.phone}}</div>
        </el-form-item>
        <el-form-item label="Skype"  >
            <div>{{result.skype}}</div>
        </el-form-item>
        <el-form-item label="QQ"  >
            <div>{{result.qq}}</div>
        </el-form-item>
        <el-form-item label="Wechat"  >
            <div>{{result.wechat}}</div>
        </el-form-item>
        <el-form-item label="Remark"  >
            <div>{{result.remark}}</div>
        </el-form-item>
    </el-form>
</template>
<script>
export default {
	data() {
		return {
			result: {}
		};
	},
	methods:{
		async loaddata(v){
            const data = await this.$post('/user/list',{where:{ user_id: v}});
            this.result = data.rows[0];
		}
	},
	props: ["id"],
	watch: {
		id(v) {
			this.loaddata(v);
		}
	},
	mounted(){
		this.loaddata(this.id);
	}
};
</script>


<style scoped>
.detail-tab{
    background-color: rgb(175, 187, 236);
    height: 30px;
    width: 100%;
    text-align: center;
vertical-align: bottom;
}
.el-form-item {
    /* margin:0 10px 0 10px; */
    width: 100%;
    border-style: solid;
    border-color:rgb(230,230,230);
    border-width: 0px 0px 1px 0px;
}
</style>
